<plugins-notice
  type="toast-float"
  [color]="data.color ?? ''"
  (dismiss)="onClose()"
  *ngIf="showToast"
  @toast
  (@toast.done)="onAnimationDone()"
>
  @let message = data.message | nl2br;
  @if (message) {
    <div [innerHTML]="message | dompurify"></div>
  }
</plugins-notice>
